var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "multiple-pages"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20833 15C5.20833 14.6548 5.48816 14.375 5.83333 14.375H11.6667C12.0118 14.375 12.2917 14.6548 12.2917 15C12.2917 15.3451 12.0118 15.625 11.6667 15.625H5.83333C5.48816 15.625 5.20833 15.3451 5.20833 15Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20833 11.6666C5.20833 11.3214 5.48816 11.0416 5.83333 11.0416H6.66667C7.01184 11.0416 7.29167 11.3214 7.29167 11.6666C7.29167 12.0118 7.01184 12.2916 6.66667 12.2916H5.83333C5.48816 12.2916 5.20833 12.0118 5.20833 11.6666Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20833 8.33329C5.20833 7.98811 5.48816 7.70829 5.83333 7.70829H8.33333C8.67851 7.70829 8.95833 7.98811 8.95833 8.33329C8.95833 8.67847 8.67851 8.95829 8.33333 8.95829H5.83333C5.48816 8.95829 5.20833 8.67847 5.20833 8.33329Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20833 1.66663C5.20833 1.32145 5.48816 1.04163 5.83333 1.04163H13.75C13.9158 1.04163 14.0747 1.10747 14.1919 1.22468L17.9419 4.97468C18.0592 5.09189 18.125 5.25087 18.125 5.41663V15.8333C18.125 16.1785 17.8452 16.4583 17.5 16.4583C17.1548 16.4583 16.875 16.1785 16.875 15.8333V5.67551L13.4911 2.29163H5.83333C5.48816 2.29163 5.20833 2.0118 5.20833 1.66663Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 4.79163C3.40482 4.79163 3.125 5.07145 3.125 5.41663V17.0833C3.125 17.4285 3.40482 17.7083 3.75 17.7083H13.75C14.0952 17.7083 14.375 17.4285 14.375 17.0833V7.34218L11.8244 4.79163H3.75ZM1.875 5.41663C1.875 4.38109 2.71447 3.54163 3.75 3.54163H11.8762C12.1746 3.54163 12.4607 3.66015 12.6717 3.87113L15.2955 6.4949C15.5065 6.70588 15.625 6.99203 15.625 7.2904V17.0833C15.625 18.1188 14.7855 18.9583 13.75 18.9583H3.75C2.71447 18.9583 1.875 18.1188 1.875 17.0833V5.41663Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 3.54163C12.0118 3.54163 12.2917 3.82145 12.2917 4.16663V6.87496H15C15.3452 6.87496 15.625 7.15478 15.625 7.49996C15.625 7.84514 15.3452 8.12496 15 8.12496H12.1667C11.5453 8.12496 11.0417 7.62128 11.0417 6.99996V4.16663C11.0417 3.82145 11.3215 3.54163 11.6667 3.54163Z",
    fill: "#656579"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleDoc);
export default __webpack_public_path__ + "static/media/multiple-doc.728bcc085cbd4d4fbc44d1d4081104e6.svg";
export { ForwardRef as ReactComponent };